module.exports = __webpack_public_path__ + "img/soja.ff8f818e.svg";